import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

// 👉 Publication data (name + PDF link)
const publications = [
  {
    name: "C1C2 TB AND MYELOMA",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/C1C2+TB+AND+MYELOMA.pdf",
  },
  {
    name: "disseminated_nocardiosis__a_rare_presentation_with.5",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/disseminated_nocardiosis__a_rare_presentation_with.5.pdf",
  },
  {
    name: "Does_Late_Presentation_of_Displaced_Supr",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/Does_Late_Presentation_of_Displaced_Supr.pdf",
  },
  {
    name: "IM NAIL BG",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/IM+NAIL+BG.pdf",
  },
  {
    name: "NATIONAL JOURNAL OF CLINICAL ORTHO",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/NATIONAL+JOURNAL+OF+CLINICAL+ORTHO.pdf",
  },
  {
    name: "THE FOOT",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/THE+FOOT.pdf",
  },
  {
    name: "TKR",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/TKR.pdf",
  },
  {
    name: "a_clinical_and_radiological_study_of_nontraumatic.4",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/a_clinical_and_radiological_study_of_nontraumatic.4.pdf",
  },
  {
    name: "ASPERGILLOSIS FA",
    pdf: "https://drpuspaksamal.s3.ap-south-1.amazonaws.com/ASPERGILLOSIS+FA.pdf",
  },
];

const Publication = () => {
  const textSwiperRef = useRef(null);

  const openPDF = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="testimonial-section publication-section py-5">
      <div className="container text-center">
        {/* <span className="testimonial-badge">💙 Publication&apos;s Research</span> */}
        <h2 className="fw-bold my-3 section-title text-black">
          Publication &amp; Research
        </h2>
        <p className="section-subtitle mb-4">
          Explore clinical studies, case reports, and research publications authored by our team.
        </p>

        <Swiper
          slidesPerView={3}
          centeredSlides={true}
          spaceBetween={30}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          speed={800}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Navigation, Autoplay]}
          className="mb-5"
          onSwiper={(swiper) => (textSwiperRef.current = swiper)}
          onMouseEnter={() => textSwiperRef.current?.autoplay?.stop()}
          onMouseLeave={() => textSwiperRef.current?.autoplay?.start()}
        >
          {publications.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="publication-card d-flex align-items-center justify-content-center"
                onClick={() => openPDF(item.pdf)}
                style={{ cursor: "pointer" }}
              >
                <div className="pub-index-badge">#{index + 1}</div>

                <div className="publication-inner d-flex align-items-center gap-3 w-100">
                  <div className="pub-icon flex-shrink-0">📄</div>

                  <div className="text-start flex-grow-1">
                    <h4 className="pub-name mb-1">{item.name}</h4>
                    <p className="pub-meta mb-0">
                      View full PDF <span className="pub-arrow">↗</span>
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Publication;
